export const loading = {
  saving: 'Saving...',
  loading: 'Loading...',
  noCurrentUser: 'Unable to load user data. Try reloading this page or logging in again.',
  authenticating: 'Authenticating...',
  pageDidntLoad: 'Error while loading, please refresh your browser.',
  timedOut: 'Request timed out.  Please try again.',
  croppingImage: 'Cropping Image...',
  loadMore: 'Load More',
};

export const loadingError = {
  maps: 'Maps are not available',
  noConnection: 'Server connection failed. Trying again might work.',
};
